export default {
  registration: {
    confirm: {
      creerCompte: 'Create your account',
      success: 'Your account has been activated',
      token: {
        notfound: 'The link you used was not found',
        expired:
          'The link you used has expired, please contact the CIEM for more information',
        success:
          'Please confirm or change your email address and mobile phone number, and set your password',
        error: {
          confirmregistration:
            'An error occurred while confirming your account, please contact the CIEM for more information',
        },
      },
    },
    cgu: {
      title: 'LEGAL NOTICE AND CGU',
      lu: 'I have read ',
    },
    donneesConnexion: {
      presentation:
        '<p>Access to this site is secured by two-factor authentication. For this to work, it is necessary to enter a cell phone number and an email address. You can then authenticate yourself with:</p>\n<ul>\n<li>Your email</li>\n<li>Your phone number</li>\n<li>Your CIEM participant number</li>\n</ul>',
      explication:
        '<p>Your pre-filled connection data are the ones known by the CIEM. We recommend that you save personal data here in order to secure your connection. These data will not be used for any other purpose.</p>',
    },
    validationDMC: {
      title: 'Access to the medical file',
      accepter:
        'By checking this box, I agree to open secure access to my online medical file. I will find all of my medical documents in my space (which I can choose to view or save on my terminal).',
      refuser:
        'By checking this box, I oppose opening access to my online medical file. I prefer to stay with the paper version of the balance sheet and I am advised that if necessary, I will have to request the communication of my documents in paper version which will be sent to me by post.',
      error: 'An answer is mandatory',
    },
    expire: {
      title: 'Link expired',
      text: 'This link is expired, please contact CIEM for more information.',
      resendregistration: 'This link has expired',
      resendregistrationButton: 'Receive a new link',
      textNewLienEnvoye: 'The new link has been sent to your mailbox',
    },
    presentation: 'Presentation',
    otp: 'Confirmation code',
    otpError: 'Error on sending confirmation code',
    presentationAdherent:
      'The CIEM offers all its members access to their professional and personal contact details, and to the medical documents created during their visits to the CIEM. You are about to activate your Extraciem account.',
    rappelCoordonnees:
      'Reminder of your professional contact details on which you are contacted by the CIEM for the management of your health check-up',
    emailProfessionnel: 'Professional email address',
    portableProfessionnel: 'Professional cellphone',
    messageActivationCompteAdherent:
      'To activate your account, Please enter your personal details (Email and mobile) necessary for the management of your personal Extraciem account, and define your password. <br/> Please also read the general conditions of use presenting you the DMC services, and to accept or refuse these conditions.',
    dataConnexion: 'Login details',
    dataConnexionSecret: 'Confidential',
    activerCompte: 'Activate your account',
    dataConnexionIncorrecte: 'Please correct your login details',
    cguIncomplet: "You haven't answered yet",
    confidentielIncorrect: 'Please to correct',
    emailPersonnel: 'Personal email address',
    portablePersonnel: 'Personal cellphone number',
    presentationCorrespondant:
      'CIEM offers company and head office correspondents the management of their participants. You are about to activate your Extraciem account.',
    messageActivationCompteCorrespondant:
      'To activate your account, please define your password, and take note of your connection details for your Extraciem account',
    emailConnexion: 'Email address for connecting to the ExtraCIEM account',
    portableConnexion:
      'Cellphone number for connecting to the ExtraCIEM account',
    lireTout: 'Please scroll to the bottom of the page',
    error: {
      duplicateportable:
        'Another account has the same personal mobile phone number.',
      duplicatemail: 'Another account has the same personal email address.',
    },
  },
}
